import { combineReducers, Reducer, ReducersMapObject } from "redux";
import { LocationState } from "redux-first-router";
import { StateWithHistory } from "redux-undo";
import { LoaderState } from "./loader/loader";
import { SnappingState } from "./snapping/types";
import { reducer as sp, SpState } from "./sp/sp";
import { CatalogState } from "./catalog/catalog";
import { ClassificationState } from "./classification/classification";
import { DialogsState } from "./dialogs/dialogs";
import { reducer as editFeature, EditFeatureState } from "./editFeature/editFeature";
import { reducer as geometryEditor, GeometryEditorState } from "./geometryEditor/geometryEditor";
import { GeocodeState } from "./geocode/geocode";
import { MapViewState } from "./mapView/mapView";
import { MeasurerState } from "./measurer/measurer";
import { MouseLabelState } from "./mouseLabel/mouseLabel";
import { NotificationsState, reducer as notifications } from "./notifications/notifications";
import { LayerCopyrightsState, reducer as layerCopyrights } from "./layerCopyrights/layerCopyrights";
import { LayerConfigState } from "./layerConfig";
import { ProjectState } from "./project/project";
import { SharedLayersState } from "./sharedLayers/sharedLayers";
import { StyleState } from "./style/style";
import { TempSourceLayersState } from "./tempSourceLayers/tempSourceLayers";
import { UserState } from "./user";
import { PrintState } from "./print/print";
import { reducer as layout, LayoutState } from "./layout/layout";
import { reducer as dateFilter, DateFilterState } from "./dateFilter/dateFilter";
import { TableState } from "./table/types";
import { LayerTempFilterState } from "./layerTempFilter/layerTempFilter";
import { LayerTempStyleState } from "./layerTempStyle/layerTempStyle";
import { AclState } from "./acl";
import { ValidationState } from "./validation/validation";
import { TasksState } from "./tasks/types";
import { SelectFeaturesState } from "./selectFeatures/types";
import { reducer as geometrySelection, GeometrySelectionState } from "./geometrySelection/geometrySelection";
import { ZoomSelectionState } from "./zoomSelection/types";
import { reducer as zoomSelection } from "./zoomSelection/zoomSelection";
import { reducer as theme, ThemeState } from "./theme/theme";
import { reducer as tempLayer, TempLayerState } from "./tempLayer/tempLayer";
import { reducer as layers, LayersState } from "./layers/layers";
import { reducer as dashboard, DashboardState } from "./dashboard/dashboard";
import { ShowFeatureState } from "./showFeature/types";
import { AppConfigState } from "../appConfig/types";
import { ProjectConfigState } from "./projectConfig";
import { reducer as chat, ChatState } from "./chat/chat";

export interface RootState {
  user?: UserState;
  location?: LocationState;
  sp: SpState;
  notifications: NotificationsState;
  layout: LayoutState;
  mapView?: StateWithHistory<MapViewState>;
  // TODO why so hard?
  style?: StateWithHistory<StyleState>;
  layerTempFilter?: LayerTempFilterState;
  layerTempStyle?: LayerTempStyleState;
  catalog?: CatalogState;
  classification?: StateWithHistory<ClassificationState>;
  dialogs?: DialogsState;
  sharedLayers?: SharedLayersState;
  measurer?: MeasurerState;
  project?: ProjectState;
  geocode?: GeocodeState;
  selectFeatures?: SelectFeaturesState;
  showFeature?: ShowFeatureState;
  geometryEditor: GeometryEditorState;
  editFeature: StateWithHistory<EditFeatureState>;
  mouseLabel?: MouseLabelState;
  print?: PrintState;
  table?: TableState;
  acl?: AclState;
  validation?: ValidationState;
  tasks?: TasksState;
  appConfig?: AppConfigState;
  layerConfig?: LayerConfigState;
  projectConfig?: ProjectConfigState;
  layerCopyrights?: LayerCopyrightsState;
  geometrySelection?: GeometrySelectionState;
  dateFilter: DateFilterState;
  snapping?: SnappingState;
  zoomSelection?: ZoomSelectionState;
  loader?: LoaderState;
  theme?: ThemeState;
  tempLayer?: TempLayerState;
  layers?: LayersState;
  dashboard?: DashboardState;
  tempSourceLayers?: TempSourceLayersState;
  chat?: ChatState;
}

export function createReducer({
  location,
  ...injectedReducers
}: ReducersMapObject & { location: Reducer<LocationState<unknown, unknown>> }) {
  return combineReducers({
    sp,
    notifications,
    layout,
    dateFilter,
    editFeature,
    geometryEditor,
    location,
    layerCopyrights,
    geometrySelection,
    zoomSelection,
    theme,
    tempLayer,
    layers,
    dashboard,
    chat,
    ...injectedReducers,
  });
}
